import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-modal-form',
  templateUrl: './modal-form.component.html',
  styleUrls: ['./modal-form.component.scss'],
})
export class ModalFormComponent implements OnChanges {
  @Input() title: string = ''; // Título del modal
  @Input() config: any[] = []; // Configuración del formulario
  @Input() customValidator:any;
  @Input() data: any = {}; // Datos iniciales para editar
  @Input() mensajeError: any = {};

  @Output() save = new EventEmitter<any>(); // Evento para enviar datos
  @Output() cancel = new EventEmitter<void>(); // Evento para cancelar

  form:FormGroup;

  constructor() {}

  ngOnChanges(): void {
    $("#addEditModal").show();
  }

  retrieveForm(formulario: FormGroup) {
    this.form = formulario;
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.save.emit(this.form.value);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
